import { render, staticRenderFns } from "./relic-upload-cropper.vue?vue&type=template&id=d0fc32e8"
import script from "./relic-upload-cropper.vue?vue&type=script&lang=js"
export * from "./relic-upload-cropper.vue?vue&type=script&lang=js"
import style0 from "./relic-upload-cropper.vue?vue&type=style&index=0&id=d0fc32e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports